import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getAcceptJobList = createAsyncThunk(
  "acceptJobList/getAcceptJobList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/cleaning/accept_job`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const acceptJobSlice = createSlice({
  name: "acceptJobList",
  initialState: {
    loading: false,
    acceptJobData: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAcceptJobList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAcceptJobList.fulfilled, (state, action) => {
        state.loading = false;
        state.acceptJobData = action.payload;
      })
      .addCase(getAcceptJobList.rejected, (state, action) => {
        state.loading = false;
        state.acceptJobData = action.payload;
        state.error = action.payload;
      });
  },
});

export default acceptJobSlice.reducer;
